// extracted by mini-css-extract-plugin
export default {"container":"whyScube_container__7Hsty","why-scube":"whyScube_why-scube__ISHva","why-scube__content":"whyScube_why-scube__content__Qr7Tg"};